module.exports = __webpack_public_path__ + "img/Madhu.4bb4dc1c.jpg";